<template>
  <div class="product-info-component">
    <el-form :inline="true" style="display: flex">
      <!-- <el-row> -->
      <el-form-item>
        <el-radio-group v-model="activeIndex" class="radio-group" v-if="tabsData.length">
          <el-radio-button :label="item.index" v-for="(item, index) in tabsData" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="margin-left: auto">
        <!-- code="iot_protocol_class" -->
        <custom-select
          class="radio-group"
          filterable
          :clearable="false"
          :isDefault="true"
          :auto="!!productSn"
          :listener="`${this.productSn || 'null'}`"
          v-model="protocolCode"
          url="productProtocolList"
          :props="{ label: 'protocolCode', value: 'protocolCode' }"
          :params="{ productSn: this.productSn }"
          @change="onProtocolCodeChange"
          width="130px"
          :placeholder="$t('dms_product_info_component.xuan_ze')"
        ></custom-select>
      </el-form-item>
      <!-- </el-row> -->
    </el-form>
    <div class="table-bd">
      <custom-table :data="curTableList" index class="table" :column="tableColumn" :slots="['componentIcon']" @filter="filterChange" @sort="sortChange">
        <template v-slot:componentIcon="scope">
          <i class="icon" :class="scope.row.componentIcon"></i>
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTable from '@/components/customTable.vue';

export default {
  components: {
    customTable,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableCode: 'product_preview_list',
      productStructureList: [],
      activeIndex: 0,
      tabsData: [],
      protocolCode: null,
      protocolType: '',
    };
  },
  computed: {
    curTableList() {
      if (this.productStructureList && this.productStructureList.length) {
        if (this.activeIndex === 0) {
          const ret = [];
          this.productStructureList.forEach((item) => {
            ret.push(...item.children);
          });
          return ret;
        }
        return this.productStructureList[this.activeIndex - 1].children;
      }
      return [];
    },
    productSn() {
      return this.data.productSn;
    },
  },
  methods: {
    async getProductStructureList() {
      // const productCode = this.data.productCode;
      return this.$getJSON(apis.productComponentList, { protocolCode: this.protocolCode, protocolType: this.protocolType }).then(res => res.data);
    },
    productStructureListToTabsData(list) {
      return list.map((item, index) => ({
        label: item.componentName,
        index: index + 1,
      }));
    },
    async init(options = {}) {
      this.activeIndex = options.activeIndex || 0;
      if (!this.protocolCode) {
        const protocolCodes = await this.getProtocolList();
        this.protocolCode = protocolCodes;
      }

      const productStructureList = await this.getProductStructureList();
      const tabsData = this.productStructureListToTabsData(productStructureList);
      if (tabsData.length) {
        tabsData.unshift({
          label: this.$t('Common.com_all'),
          index: 0,
        });
      }

      this.tabsData = tabsData;
      this.productStructureList = productStructureList;
    },
    // 获取产品协议列表
    getProtocolList: function () {
      return this.$getJSON(apis.productProtocolList, {
        productSn: this.data.productSn,
      }).then(res => res.data.map(t => t.protocolCode).join(','));
    },
    //
    onProtocolCodeChange(item) {
      if (item) {
        this.protocolType = item.protocolType;
        this.init();
      }
    },
  },
  mounted() {
    this.getTableColumn();
  },
};
</script>

<style lang="scss" scoped>
.product-info-component {
  .radio-group {
    margin-top: 24px;
  }
  .table {
    margin-top: 16px;
  }
}
</style>
